import ScaleLoader from "react-spinners/ScaleLoader";

const Loader = () => {
  return (
    <div className="top-0 left-0 z-[9999] w-full h-full flex items-center justify-center fixed bg-white">
      <div className="loader">
        <ScaleLoader loading={true} />
      </div>
    </div>
  );
};

export default Loader;
